import  { useEffect ,useState, useRef} from 'react';
import './RentSuccessPage.css';
import RefundPolicySuccess from '../RefundPolicySuccess/RefundPolicySuccess';
import Tab from "bootstrap/js/dist/tab"; // Import Bootstrap Tab specifically
import AOS from 'aos';
import 'aos/dist/aos.css';
import AIheader from '../../../pages/RentAI/AIheader';


import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

const RentSuccessPage = ()=>{



    
   // START abcPause //
   useEffect(() => {
    const handleMouseEnter = () => {
      document.querySelector(".cancel_Left").classList.add("abcPause");
    };
    
    const handleMouseLeave = () => {
      document.querySelector(".cancel_Left").classList.remove("abcPause");
    };
    
    const element = document.querySelector(".cancel_Right");
    if (element) {
      element.addEventListener("mouseenter", handleMouseEnter);
      element.addEventListener("mouseleave", handleMouseLeave);
    }
    
    return () => {
      if (element) {
        element.removeEventListener("mouseenter", handleMouseEnter);
        element.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, []);

   // END abcPause //


    // START CancelPolicySuccessMain //
    const tabs = ["tabCancelPolicy_1", "tabCancelPolicy_2", "tabCancelPolicy_3", "tabCancelPolicy_4"]; // Array of tab IDs
    const [currentTabIndex, setCurrentTabIndex] = useState(0); // Current tab index
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null); 
    
    const lastTimeRef = useRef(Date.now()); 
    const remainingTimeRef = useRef(5000);

    const switchTab = () => {
        const nextTabIndex = (currentTabIndex + 1) % tabs.length;
        setCurrentTabIndex(nextTabIndex);
        
        // Show the next tab
        const nextTabId = tabs[nextTabIndex];
        const nextTab = new Tab(document.getElementById(nextTabId));
        nextTab.show();

        lastTimeRef.current = Date.now(); 
        remainingTimeRef.current = 5000; 
    };

    useEffect(() => {
        if (isPaused) return;

        intervalRef.current = setTimeout(switchTab, remainingTimeRef.current);

        return () => clearTimeout(intervalRef.current);
    }, [currentTabIndex, isPaused]);

    const handleMouseEnter = () => {
        if (!isPaused) {
            clearTimeout(intervalRef.current);
            remainingTimeRef.current -= Date.now() - lastTimeRef.current; 
            setIsPaused(true);
        }
    };

    const handleMouseLeave = () => {
        lastTimeRef.current = Date.now(); 
        setIsPaused(false); 
    };


    const onrent_tab = ["onRentGuidelines_1", "onRentGuidelines_2"];
    const business_tab = ["businessEmpowerment_1", "businessEmpowerment_2","businessEmpowerment_3"];
    const [activeTab1, setActiveTab1] = useState("onRentGuidelines_1");
    const [activeTab, setActiveTab] = useState(business_tab[0]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
 

  useEffect(() => {
    AOS.init({
        duration: 1000,
        offset: 100,
        delay: 500,
        easing: 'ease-in-sine',
        anchorPlacement: 'top-bottom',
      once: false,  
    });

    const handleTabShown = () => {
        setTimeout(() => {
          AOS.refresh(); // Or use AOS.refreshHard() if content is dynamic
        }, 100);
      };
  
      const tabs = document.querySelectorAll('[data-bs-toggle="tab"]');
      tabs.forEach((tab) => {
        tab.addEventListener('shown.bs.tab', handleTabShown);
      });
  
      return () => {
        tabs.forEach((tab) => {
          tab.removeEventListener('shown.bs.tab', handleTabShown);
        });
      };
      
  }, []);




  useEffect(() => {
    if (!isInitialLoad) return; // Prevent overriding user action
  
    const hash = window.location.hash;
  
    // Check Business Empowerment Tabs
    const businessIndex = business_tab.findIndex(tab => `#${tab}` === hash);
    if (businessIndex !== -1) {
      setActiveTab(business_tab[businessIndex]);
    }
  
    // Check On Rent Guidelines Tabs
    const onRentIndex = onrent_tab.findIndex(tab => `#${tab}` === hash);
    if (onRentIndex !== -1) {
      setActiveTab1(onrent_tab[onRentIndex]);
    }
  
    setIsInitialLoad(false); // Prevent further auto-setting of tabs
  }, [isInitialLoad]);


  useEffect(() => {
    // Reinitialize AOS whenever the active tab changes
    AOS.refresh();
  }, [activeTab, activeTab1]);

//   useEffect(() => {
//     // Automatically switch tabs for both business_tab and onrent_tab every 2 seconds
//     const interval = setInterval(() => {
//       setActiveTab((prevTab) => {
//         const currentIndex = business_tab.indexOf(prevTab);
//         const nextIndex = (currentIndex + 1) % business_tab.length; // Cycle through business_tab
//         return business_tab[nextIndex];
//       });
  
//       setActiveTab1((prevTab) => {
//         const currentIndex = onrent_tab.indexOf(prevTab);
//         const nextIndex = (currentIndex + 1) % onrent_tab.length; // Cycle through onrent_tab
//         return onrent_tab[nextIndex];
//       });
//     }, 3000);
  
//     return () => clearInterval(interval); // Cleanup on unmount
//   }, [business_tab, onrent_tab]);
  
  
    
   // START accordian //
//    const [isClient, setIsClient] = useState(false);

//    useEffect(() => {
//        const hash = window.location.hash;
//        if (hash) {
//          setTimeout(() => {
//            const element = document.querySelector(hash);
//            if (element) {
//              const headerOffset = 80; // Adjust according to your header height
//              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
//              window.scrollTo({
//                top: elementPosition - headerOffset,
//                behavior: "smooth",
//              });
//            }
//          }, 100); // Delay to ensure DOM is loaded
//        }
//      }, []);
     

//    useEffect(() => {
//      setIsClient(true);
//    }, []);
 
//    if (!isClient) return null;
   // END accordian //


    return(
        <>
            <AIheader/>


            {/* START bannerInnerMain */}
            <section className="bannerInnerMain bannerSuccessMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="bannerPageInner">
                                <figure><img src="/img/rentsuccess/rentSuccess_icon_banner.svg" alt="Guest violation"/></figure>
                                <h1>Guest violation & dispute resolution for rental fleets and operators</h1>
                                <p>Get real-time assistance and structured policy management to handle rental issues effortlessly</p>
                       
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerInnerMain */}


            {/* START successfulRentalsMain */}
            <section className='successfulRentalsMain'>
                <div className='container'>
                <div className='row align-items-center'>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                    <div className='successfulRentalsLeft'>
                        <h6>DIGITAL BACK OFFICE SUCCESS CENTER</h6>
                        <h2>The go-to crew for successful rentals</h2>
                        <p>Seamless support for rental issues with clear policy management, direct communication, and real-time assistance to keep customers happy, your fleet protected, and trips running. </p>
                        <ul>
                            <li>
                                <a href="#ResolutionCenter">
                                    <img width="24px" height="24px"src="/img/user_group_icon.svg" alt="commercial_icon" />
                                    Resolution Center
                                </a>
                            </li>
                            <li>
                                <a href="#CancellationPolicies">
                                    <img width="24px" height="24px"src="/img/business_icon.svg" alt="car-shield" />
                                    Cancellation Policies
                                </a>
                            </li>

                            <li>
                                <a href="#BusinessEmpowerment">
                                    <img width="24px" height="24px"src="/img/tow_truck_icon.svg" alt="user" />
                                    Business Empowerment
                                </a>
                            </li>

                            <li>
                                <a href="#OnRentGuidelines">
                                    <img width="24px" height="24px"src="/img/refresh_car_icon.svg" alt="tow truck" />
                                    On Trip Assistance 
                                </a>
                            </li>
                            <li>
                                <a href="#TechnicalSupport">
                                    <img width="24px" height="24px"src="/img/settings_icon.svg" alt="web protection" />
                                    Technical Support
                                </a>
                            </li>
                            <li>
                                <a href="#rentalSupportAgent">
                                    <img width="24px" height="24px"src="/img/bulb_charging_icon.svg" alt="digital" />
                                    Rental Support Agent
                                </a>
                            </li>
                        </ul>
                    </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                        <div className='successfulRentalsRight'>
                            <img className="img-fluid" src="/img/rentsuccess/successfulRentalsRight.webp" alt="Successful Rentals" />
                        </div>
                    </div>
                </div>
                </div>
            </section>
            {/* END successfulRentalsMain */}

            {/* START resolutionSuccessMain */}
            <section className='resolutionSuccessMain' id='ResolutionCenter'>
                <img className="resolutionSuccess_1" src="/img/rentsuccess/resolutionSuccess_1.png" alt="banner"/>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                            <div className='headResolutionSuccess'>
                                <h6>ADMINISTRATIVE BACK OFFICE</h6>
                                <h2>Resolution Center</h2>
                                <p>Back-office support for car rental industry. Recover funds faster, reduce admin tasks, 
                                    and save money with tools that simplify overages and complex disputes.</p>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='resolutionSuccessInner'>
                                    <figure>
                                    <img className="img-fluid" src="/img/rentsuccess/resolutionSuccess.webp" alt="Resolution Center"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END resolutionSuccessMain */}

            <RefundPolicySuccess/> 



            {/* START CancelPolicySuccessMain */}
            <section className="CancelPolicySuccessMain" id='CancellationPolicies'>
            <img className="cancelSuccess_1" src="/img/rentsuccess/cancelSuccess_1.svg" alt="Cancellation policies"/>
                <div className="container">
                    <div className='row justify-content-center'>
                        <div className="col-md-10">
                            <div className="headCancelSuccess">
                            <h2><span>Cancellation policies </span>that fit your business risk. </h2>
                            <p>Ensure guest satisfaction and financial security with flexible cancellation options. Customize policies 
                                for individual vehicles or apply a global policy to your entire fleet.</p>
                            </div>
                        </div>
                    </div>
               
                    <div className='row align-items-center'>
                        <div className='col-lg-3 col-md-12 col-sm-12 col-12 cancel_Left'>
                            <div className='cancelSuccessLeft'>
                                <ul className="nav nav-tabs">
                                    <li className="nav-item"  onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                        <a className="nav-link active" id="tabCancelPolicy_1" data-bs-toggle="tab" href="#CancelPolicySuccess_1">
                                            <span>Relaxed Policy</span>
                                            <img className="iconCancel" width="24px" height="24px" src="/img/rentsuccess/arrow_bottom_white.svg" alt="icon"/>
                                            <img className="iconCancelActive" width="24px" height="24px" src="/img/rentsuccess/arrow_right_white.svg" alt="icon"/>
                                        </a>
                                    </li>
                                    <li className="nav-item" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                        <a className="nav-link" id="tabCancelPolicy_2" data-bs-toggle="tab" href="#CancelPolicySuccess_2" >
                                            <span>Flexible Policy</span>
                                            <img className="iconCancel" width="24px" height="24px" src="/img/rentsuccess/arrow_bottom_white.svg" alt="icon"/>
                                            <img className="iconCancelActive" width="24px" height="24px" src="/img/rentsuccess/arrow_right_white.svg" alt="icon"/>
                                        </a>
                                    </li>
                                    <li className="nav-item" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                        <a className="nav-link" id="tabCancelPolicy_3" data-bs-toggle="tab" href="#CancelPolicySuccess_3" >
                                            <span>Moderate Policy</span>
                                            <img className="iconCancel" width="24px" height="24px" src="/img/rentsuccess/arrow_bottom_white.svg" alt="icon"/>
                                            <img className="iconCancelActive" width="24px" height="24px" src="/img/rentsuccess/arrow_right_white.svg" alt="icon"/>
                                        </a>
                                    </li>
                                    <li className="nav-item" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                        <a className="nav-link" id="tabCancelPolicy_4" data-bs-toggle="tab" href="#CancelPolicySuccess_4" >
                                            <span>Firm Policy</span>
                                            <img className="iconCancel" width="24px" height="24px" src="/img/rentsuccess/arrow_bottom_white.svg" alt="icon"/>
                                            <img className="iconCancelActive" width="24px" height="24px" src="/img/rentsuccess/arrow_right_white.svg" alt="icon"/>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-lg-9 col-md-12 col-sm-12 col-12 cancel_Right'>
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className="tab-pane active" id="CancelPolicySuccess_1" >
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                                            <div className="cancelSuccessMiddle" data-aos="fade-in" data-aos-delay="200" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                                <h3>Relaxed Policy </h3>
                                                <h4>Provide the ultimate guest experience:</h4>
                                                <p>Full refund for cancellations at any time up to the pickup time.</p>
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                                            <div className='cancelSuccessRight' data-aos="zoom-in" data-aos-delay="200">
                                                <figure>
                                                    <img src="/img/rentsuccess/rentsuccess_cancellation_policy.webp" alt="RentSuccess"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 1 */}

                                {/* START Tab 2 */}
                                <div className="tab-pane fade" id="CancelPolicySuccess_2">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                                            <div className="cancelSuccessMiddle" data-aos="fade-in" data-aos-delay="200">
                                                <h3>Flexible Policy</h3>
                                                <h4>Cover your expenses and remain flexible:</h4>
                                                <p>Full refund for cancellation within 24 hours. 75% refund for cancellations up to the pickup time.</p>
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                                            <div className='cancelSuccessRight' data-aos="zoom-in" data-aos-delay="200" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                                <figure>
                                                    <img src="/img/rentsuccess/rentsuccess_flexxible_policy.webp" alt="RentSuccess"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 2 */}

                                {/* START Tab 3 */}
                                <div className="tab-pane fade" id="CancelPolicySuccess_3">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                                            <div className="cancelSuccessMiddle" data-aos="fade-in" data-aos-delay="200" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                                <h3>Moderate Policy</h3>
                                                <h4>Cover your expenses and re-list:</h4>
                                                <p>Full refund for cancellation within 24 hours. 75% refund for cancellations made up to 48 hours prior to the pick-up time. No refunds for cancellations within 24 hours to the pick-up time.</p>
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                                            <div className='cancelSuccessRight' data-aos="zoom-in" data-aos-delay="200"> 
                                                <figure>
                                                    <img src="/img/rentsuccess/moderate_policy.webp" alt="RentSuccess"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 3 */}

                                {/* START Tab 4 */}
                                <div className="tab-pane fade" id="CancelPolicySuccess_4">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                                            <div className="cancelSuccessMiddle" data-aos="fade-in" data-aos-delay="200" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                                <h3>Firm Policy</h3>
                                                <h4>Cover majority of booking and re-list with most amount of time:</h4>
                                                <p>Full refund for cancellations within 24 hours of the booking time, if the pick-up time is at least 3 days away. 50% refund for cancellations made up to 24 hours prior to the pick-up time. No refunds for cancellations within 24 hours to the pick-up time.</p>
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                                            <div className='cancelSuccessRight' data-aos="zoom-in" data-aos-delay="200">
                                                <figure>
                                                    <img src="/img/rentsuccess/firm_policy.webp" alt="RentSuccess"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 4 */}



                            </div>
                        </div>
                    </div>
                
                </div>
            </section>
            {/* END CancelPolicySuccessMain */}

    

            {/* START businessEmpowermentMain */}

            <div id='BusinessEmpowerment'>
                <section className="businessEmpowermentMain businessEmp_DesktopMain">
                    {/* <img className="businessEmpowerment_1" src="/img/rentsuccess/businessEmpowerment_1.svg" alt="Business Empowerment"/> */}
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9">
                                <div className="headBusinessEmpowerment">
                                    <h2>Business Empowerment</h2>
                                    <p>We’re here to assist your rental journey every step of the way.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <ul className="nav nav-tabs maintabs-hide">
                                    <li className="nav-item">
                                        <button
                                        className={`nav-link ${activeTab === "businessEmpowerment_1" ? "active" : ""}`}
                                        onClick={() => setActiveTab("businessEmpowerment_1")}>
                                            <img width="22px" height="24px" src="/img/rentsuccess/success_icon.svg" alt="icon"/>
                                            <span>Resource Center</span>
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                        className={`nav-link ${activeTab === "businessEmpowerment_2" ? "active" : ""}`}
                                        onClick={() => setActiveTab("businessEmpowerment_2")}>
                                            <img width="22px" height="24px" src="/img/rentsuccess/success_icon.svg" alt="icon"/>
                                            <span>Success Manager</span>
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                        className={`nav-link ${activeTab === "businessEmpowerment_3" ? "active" : ""}`}
                                        onClick={() => setActiveTab("businessEmpowerment_3")}>
                                            <img width="22px" height="24px" src="/img/rentsuccess/success_icon.svg" alt="icon"/>
                                            <span>Marketing Team</span>
                                        </button>
                                    </li>
                                </ul>
                            
                                <div className="tab-content">
                                
                                    {activeTab === "businessEmpowerment_1" && (
                                        <div className="tab-pane active" id="businessEmpowerment_1" role="tabpanel">

                                    
                                        <div className='row align-items-center'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='businessEmpowermentLeft'>
                                                    <figure>
                                                        <img className="businessEmpowerment_11" data-aos="zoom-in" height="" width="503px" data-aos-delay="200" src="/img/rentsuccess/businessEmpowerment_11.webp" alt="business Empowerment"/>
                                                        <img className="businessEmpowerment_12" width="291px" height="502px" data-aos="slide-right" data-aos-delay="400" src="/img/rentsuccess/businessEmpowerment_12.webp" alt="business Empowerment"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='businessEmpowermentRight'>
                                                    <img width="48px" height="48px" src="/img/rentsuccess/resource_center.svg" alt="star"/>
                                                    <h3>Resource Center</h3>
                                                    <p>Discover everything you need to succeed on our platform. From quick answers to detailed guides, the Rentid Resource Center is your go-to for seamless operations and valuable insights.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Guides:</strong> Tutorials and instructions for platform features and workflows.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>FAQs:</strong> Quick answers to common platform questions.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Support Access:</strong> Direct links to contact support or live chat for assistance.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Knowledge Base:</strong> Articles and best practices for optimizing platform use.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Announcements:</strong> Stay informed on new features, fixes, and improvements.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )}

                                

                                    {activeTab === "businessEmpowerment_2" && (
                                        <div className="tab-pane active" id="businessEmpowerment_2" role="tabpanel">
                                        <div className='row align-items-center'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='businessEmpowermentLeft'>
                                                    <figure>
                                                        <img className="businessEmpowerment_21" data-aos="zoom-in" data-aos-delay="100" src="/img/rentsuccess/businessEmpowerment_21.png" alt=" "/>
                                                        <img className="businessEmpowerment_22" data-aos="slide-left" data-aos-delay="200" src="/img/rentsuccess/businessEmpowerment_22.png" alt=" "/>
                                                        <img className="businessEmpowerment_23" data-aos="slide-left" data-aos-delay="300" src="/img/rentsuccess/businessEmpowerment_23.png" alt=" "/>
                                                        <img className="businessEmpowerment_24" data-aos="slide-left" data-aos-delay="400" src="/img/rentsuccess/businessEmpowerment_24.png" alt=" "/>
                                                        <img className="businessEmpowerment_25" data-aos="slide-left" data-aos-delay="500" src="/img/rentsuccess/businessEmpowerment_25.png" alt=" "/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='businessEmpowermentRight'>
                                                    <img width="48px" height="48px" src="/img/rentsuccess/dynamic_icon.svg" alt="star"/>
                                                    <h3>Success Manager</h3>
                                                    <p>Our Account Management team is here to support you and your staff with all your account and platform needs. 
                                                        Whether you have questions, need guidance, or want to explore solutions, we're just a conversation away.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Personalized Support:</strong> Dedicated assistance tailored to your unique account and platform requirements.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Expert Guidance:</strong> Get answers from professionals who know the ins and outs of our system.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Seamless Communication:</strong> Easy access to help through multiple channels, ensuring your concerns are addressed quickly.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Proactive Solutions:</strong> We work with you to identify opportunities and optimize your experience on our platform.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    )}

                                    {activeTab === "businessEmpowerment_3" && (
                                        <div className="tab-pane active" id="businessEmpowerment_3" role="tabpanel">
    
                                    <div className='row align-items-center'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='businessEmpowermentLeft'>
                                                    <figure>
                                                        <img className="businessEmpowerment_31" data-aos="zoom-in" data-aos-delay="200" src="/img/rentsuccess/businessEmpowerment_31.png" alt=""/>
                                                        <img className="businessEmpowerment_32" data-aos="slide-left" data-aos-delay="200" src="/img/rentsuccess/businessEmpowerment_32.png" alt=""/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='businessEmpowermentRight businessEmpowermentRight_3'>
                                                    <h3>Cast your Vote</h3>
                                                    <h4>Managed marketing services</h4>
                                                    <p>Need more marketing support? We’ve got you covered.</p>
                                                    <p>Rentid offers managed digital marketing services to help select hosts boost brand awareness 
                                                        and attract more customers. Our services include:</p>
                                                        <ul>
                                                        <li>Social media management & advertising</li>
                                                        <li>SEO & SEM</li>
                                                        <li>Website management</li>
                                                    </ul>
                                                    <p>We’re considering offering these services at a discounted rate for interested hosts. Let us know if you'd like assistance!</p>
                        
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    )}
                                
                    

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section  className="businessEmpowermentMain businessEmp_MobileMain"> 
                    {/* <img className="businessEmpowerment_1" src="/img/rentsuccess/businessEmpowerment_1.svg" alt="Business Empowerment"/> */}
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9">
                                <div className="headBusinessEmpowerment">
                                    <h2>Business Empowerment</h2>
                                    <p>We’re here to assist your rental journey every step of the way.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="businessEmp_MobileAccordian">
                                    <Accordion defaultActiveKey="0">
                                        {/* start 1 */}
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header> 
                                                <span>Resource Center</span>
                                            </Accordion.Header>
                                            <Accordion.Body>

                                                <div className='row align-items-center'>
                                                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                        <div className='businessEmp_MobileLeft'>
                                                        <img className="img-fluid" width="500px" 
                                                            src="/img/rentsuccess/mobile_BusinessEmpowerment_1.png" alt="business Empowerment"/>
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                        <div className='businessEmp_MobileRight'>
                                                            <img width="48px" height="48px" src="/img/rentsuccess/resource_center.svg" alt="star"/>
                                                            <h3>Resource Center</h3>
                                                            <p>Discover everything you need to succeed on our platform. From quick answers to detailed guides, the Rentid Resource Center is your go-to for seamless operations and valuable insights.</p>
                                                            <ul>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Guides:</strong> Tutorials and instructions for platform features and workflows.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>FAQs:</strong> Quick answers to common platform questions.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Support Access:</strong> Direct links to contact support or live chat for assistance.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Knowledge Base:</strong> Articles and best practices for optimizing platform use.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Announcements:</strong> Stay informed on new features, fixes, and improvements.</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                        
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* start 2 */}
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header> 
                                                <span>Success Manager</span>
                                            </Accordion.Header>
                                            <Accordion.Body>
                            

                                            <div className='row align-items-center'>
                                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                    <div className='businessEmp_MobileLeft'>
                                                        <img className="img-fluid" width="500px"
                                                        src="/img/rentsuccess/mobile_BusinessEmpowerment_2.png" alt="business Empowerment"/>
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                    <div className='businessEmp_MobileRight'>
                                                        <img width="48px" height="48px" src="/img/rentsuccess/dynamic_icon.svg" alt="star"/>
                                                        <h3>Success Manager</h3>
                                                        <p>Our Account Management team is here to support you and your staff with all your account and platform needs. 
                                                            Whether you have questions, need guidance, or want to explore solutions, we're just a conversation away.</p>
                                                        <ul>
                                                            <li>
                                                                <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                <span><strong>Personalized Support:</strong> Dedicated assistance tailored to your unique account and platform requirements.</span>
                                                            </li>
                                                            <li>
                                                                <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                <span><strong>Expert Guidance:</strong> Get answers from professionals who know the ins and outs of our system.</span>
                                                            </li>
                                                            <li>
                                                                <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                <span><strong>Seamless Communication:</strong> Easy access to help through multiple channels, ensuring your concerns are addressed quickly.</span>
                                                            </li>
                                                            <li>
                                                                <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                <span><strong>Proactive Solutions:</strong> We work with you to identify opportunities and optimize your experience on our platform.</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
            
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* start 3 */}
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header> 
                                                <span>Marketing Team</span>
                                            </Accordion.Header>

                                            <Accordion.Body>
                                            <div className='row align-items-center'>
                                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                    <div className='businessEmp_MobileLeft'>
                                                        <img className="img-fluid" width="500px" 
                                                        src="/img/rentsuccess/mobile_BusinessEmpowerment_3.png" alt="business Empowerment"/>
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                    <div className='businessEmp_MobileRight businessEmp_MobileRight_3'>
                                                        <h3>Cast your Vote</h3>
                                                        <h4>Managed marketing services</h4>
                                                        <p>Need more marketing support? We’ve got you covered.</p>
                                                        <p>Rentid offers managed digital marketing services to help select hosts boost brand awareness 
                                                            and attract more customers. Our services include:</p>
                                                            <ul>
                                                            <li>Social media management & advertising</li>
                                                            <li>SEO & SEM</li>
                                                            <li>Website management</li>
                                                        </ul>
                                                        <p>We’re considering offering these services at a discounted rate for interested hosts. Let us know if you'd like assistance!</p>
                            
                                                    </div>
                                                </div>
                                            </div>
                            
                                            </Accordion.Body>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* END businessEmp_MobileMain */}

            {/* END businessEmpowermentMain */}
















            {/* START onRentGuidelinesMain */}
            <div id='OnRentGuidelines'>
                <section className="onRentGuidelinesMain onRent_DesktopMain">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9">
                                <div className="headOnRentGuidelines">
                                    <h2>On Trip Assistance</h2>
                                    <p>Supporting guests during the rental period made easy.</p>
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <ul className="nav nav-tabs on-trip-assistent-main">
                                    <li className="nav-item">
                                        <button
                                        className={`nav-link ${activeTab1 === "onRentGuidelines_1" ? "active" : ""}`}
                                        onClick={() => setActiveTab1("onRentGuidelines_1")}
                                        >
                                            <img width="22px" height="24px" src="/img/rentsuccess/success_icon.svg" alt="icon"/>
                                            <span>Resource Center</span>
                                            </button>
                        
                                    </li>
                                    <li className="nav-item">
                        
                                        <button
                                    className={`nav-link ${activeTab1 === "onRentGuidelines_2" ? "active" : ""}`}
                                    onClick={() => setActiveTab1("onRentGuidelines_2")}
                                >
                                            <img width="22px" height="24px" src="/img/rentsuccess/success_icon.svg" alt="icon"/>
                                            <span>Direct Communication </span>
                                            </button>
                                    
                                    </li>
                                </ul>
                            
                                <div className="tab-content">
                        
                                    {activeTab1 === "onRentGuidelines_1" && (
                                        <div className="tab-pane active" id="onRentGuidelines_1" role="tabpanel">
                    
                                        <div className='row align-items-center'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='onRentGuidelinesLeft'>
                                                    <figure>
                                                    <img className="onRentGuidelines_11" data-aos="zoom-in" 
                                                    width="503px" data-aos-delay="200" src="/img/rentsuccess/onRentGuidelines_11.webp" alt=""/>
                                                    <img className="onRentGuidelines_12" data-aos="slide-up" 
                                                    width="265px" data-aos-delay="400" src="/img/rentsuccess/onRentGuidelines_12.webp" alt=""/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='onRentGuidelinesRight'>
                                                    <img width="48px" height="48px" src="/img/rentsuccess/resource_center.svg" alt="star"/>
                                                    <h3>Resource Center</h3>
                                                    <p>Guest Resource Center is a feature designed to enhance your guests’ rental experience, 
                                                        providing them with easy access to the information they need. With this resource in place, 
                                                        you can focus on managing your rentals while ensuring your guests have the support they 
                                                        need at their fingertips.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Enhanced Guest Satisfaction:</strong> Guests can quickly find answers to their questions, reducing the need for direct support.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>24/7 Accessibility:</strong> The resource center is available anytime, giving your guests peace of mind around the clock.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Streamlined Communication:</strong> Save time by directing guests to clear, detailed guides and FAQs.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Professional Appearance:</strong> Professional Appearance: Offer a polished and reliable experience with a dedicated guest support feature.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                    

                            
                                    {activeTab1 === "onRentGuidelines_2" && (
                                        <div className="tab-pane active" id="onRentGuidelines_2" role="tabpanel">
                                        <div className='row align-items-center'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='onRentGuidelinesLeft'>
                                                    <figure>
                                                    <img className="onRentGuidelines_21" data-aos="zoom-in" 
                                                    width="309px" data-aos-delay="200" src="/img/rentsuccess/onRentGuidelines_21.webp" alt=""/>
                                                    <img className="onRentGuidelines_22" data-aos="slide-right" 
                                                    width="175px" data-aos-delay="200" src="/img/rentsuccess/onRentGuidelines_22.webp" alt=""/>
                                                    <img className="onRentGuidelines_23" data-aos="slide-up" data-aos-delay="200" src="/img/rentsuccess/onRentGuidelines_23.webp" alt=""/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='onRentGuidelinesRight'>
                                                    <img width="48px" height="48px" src="/img/rentsuccess/dynamic_icon.svg" alt="star"/>
                                                    <h3>Direct Communication</h3>
                                                    <p>We’ve made guest communication effortless with direct access to hosts through multiple channels. 
                                                    Whether it’s answering questions or sharing trip details, our tools keep you connected. 
                                                    Hosts can also clearly communicate trip rules and policies using our website creator and 
                                                    customizable app features, keeping guests informed and enhancing their rental experience.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Direct Messaging:</strong> Organized inbox communication for quick and efficient responses.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Multiple Contact Options:</strong> Guests can connect via phone, email, text, or social media.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Customizable Tools:</strong> Clearly share trip rules and policies through your personalized website and app features.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                            <span><strong>Reliable Communication:</strong> Always stay connected for a smooth and worry-free rental experience.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    )}
                                    
                    
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="onRentGuidelinesMain onRent_MobileMain">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9">
                                <div className="headOnRentGuidelines">
                                    <h2>On Trip Assistance</h2>
                                    <p>Supporting guests during the rental period made easy.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="onRentMobileAccordian">
                                    <Accordion defaultActiveKey="0">
                                        {/* start 1 */}
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                                <span>Resource Center</span>
                                            </Accordion.Header>
                                            <Accordion.Body>

                        
                                                <div className='row align-items-center'>
                                                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                        <div className='onRent_MobileLeft'>
                                                            <img className="img-fluid" width="512px" 
                                                            src="/img/rentsuccess/mobile_OnRentGuidelines_1.png" alt=""/>
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                        <div className='onRent_MobileRight'>
                                                            <img width="48px" height="48px" src="/img/rentsuccess/resource_center.svg" alt="star"/>
                                                            <h3>Resource Center</h3>
                                                            <p>Guest Resource Center is a feature designed to enhance your guests’ rental experience, 
                                                                providing them with easy access to the information they need. With this resource in place, 
                                                                you can focus on managing your rentals while ensuring your guests have the support they 
                                                                need at their fingertips.</p>
                                                            <ul>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Enhanced Guest Satisfaction:</strong> Guests can quickly find answers to their questions, reducing the need for direct support.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>24/7 Accessibility:</strong> The resource center is available anytime, giving your guests peace of mind around the clock.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Streamlined Communication:</strong> Save time by directing guests to clear, detailed guides and FAQs.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Professional Appearance:</strong> Professional Appearance: Offer a polished and reliable experience with a dedicated guest support feature.</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                        
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {/* start 2 */}
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>
                                                <span>Direct Communication</span>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className='row align-items-center'>
                                                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                        <div className='onRent_MobileLeft'>
                                                            <img className="img-fluid" width="458px"
                                                            data-aos="zoom-in" data-aos-delay="200" 
                                                            src="/img/rentsuccess/mobile_OnRentGuidelines_2.webp" alt=""/>
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                        <div className='onRent_MobileRight'>
                                                            <img width="48px" height="48px" src="/img/rentsuccess/dynamic_icon.svg" alt="star"/>
                                                            <h3>Direct Communication</h3>
                                                            <p>We’ve made guest communication effortless with direct access to hosts through multiple channels. 
                                                            Whether it’s answering questions or sharing trip details, our tools keep you connected. 
                                                            Hosts can also clearly communicate trip rules and policies using our website creator and 
                                                            customizable app features, keeping guests informed and enhancing their rental experience.</p>
                                                            <ul>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Direct Messaging:</strong> Organized inbox communication for quick and efficient responses.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Multiple Contact Options:</strong> Guests can connect via phone, email, text, or social media.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Customizable Tools:</strong> Clearly share trip rules and policies through your personalized website and app features.</span>
                                                                </li>
                                                                <li>
                                                                    <img width="24px" height="24px" src="/img/rentsuccess/check_white.svg" alt="icon"/>
                                                                    <span><strong>Reliable Communication:</strong> Always stay connected for a smooth and worry-free rental experience.</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                

                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* END onRentGuidelinesMain */}

            {/* START technicalSupportMain */}
            <section className="technicalSupportMain" id='TechnicalSupport'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headTechnicalSupport">
                                <h2><span>Technical Support</span> coverage when using the platform</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="technicalSupportOuter">
                    <div className="container">
                        <div className="technicalSupportInner">   
                            <div className='row align-items-center'>
                                <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                    <div className='technicalSupportLeft'>
                                            <h3 data-aos="fade-up" data-aos-delay="100"><span>Submit a ticket or talk live</span> to our technical support team anytime of day.</h3>
                                            <p data-aos="fade-up" data-aos-delay="200">Our platform provides 24/7 support to help you manage renter issues, navigate technology, 
                                            and troubleshoot systems. Designed to keep operations running smoothly, we’re here to ensure your success.</p>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                    <div className='technicalSupportRight'>
                                        <figure>
                                            <img className="img-fluid" data-aos="zoom-in" data-aos-delay="300" src="/img/rentsuccess/technicalSupport_1.webp" alt="rent success"/>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END technicalSupportMain */}



            {/* START rentalSupportAgentMain */}
            <section className="rentalSupportAgentMain" id='rentalSupportAgent'>
                <div className='rentalSupportAgent_1'>
                    <figure>
                        <img className="" src="/img/rentsuccess/rentalSupportAgent.webp" width='516px' alt="rental Support Agent" />
                    </figure>
                    <div className='power_ai'>
                        <img className="img-fluid" src="/img/power_ai.svg" alt="power ai" />
                    </div>
                </div>
                <div className="container">
                    <div className='row align-items-center'>
                        <div className='col-xxl-4 col-xl-5 col-lg-5 col-md-12'>
                            <div className='rentalSupportAgentLeft'>
                                <figure>
                                    <img className="img-fluid" src="/img/rentsuccess/rentalSupportAgent.webp" alt="rental Support Agent" />
                                </figure>
                                <div className='power_ai'>
                                    <img className="img-fluid" src="/img/power_ai.svg" alt="power ai" />
                                </div>
                            </div>
                        </div>
                        <div className='col-xxl-8 col-xl-7 col-lg-7 col-md-12'>
                            <div className='rentalSupportAgentRight'>
                                <h2 data-aos="fade-up" data-aos-delay="100">Meet <span>Rentii</span>, your rental AI support agent.</h2>
                                <p data-aos="fade-up" data-aos-delay="200">Experience the power of AI with <span>Rentii</span>, your smart companion for seamless rental support.</p>
                                <ul data-aos="fade-up" data-aos-delay="300">
                                    <li><span>Tailored Help</span></li>
                                    <li><span>Always Available</span></li>
                                    <li><span>Effortless Management</span></li>
                                </ul>
                                <a className="btn btnTransparent_3" href="/rentai" data-aos="fade-up" data-aos-delay="400">Learn More
                                    <img width="24px" height="24px" src="/img/arrow-right-white.svg" alt="icon"/>
                                </a>
                            </div>
                        </div>
                    </div>

            
                </div>
            </section>
            {/* END rentalSupportAgentMain */}

            {/* END moreSolutionMain */}
            <section className='moreSolutionMain'>
                <div className='container'>
                    <div className="row">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="moreSolutionHeading">
                                <h2>Discover more solutions</h2>
                                <p>Rental tools to help you scale your business</p>
                            </div>
                        </div>
                    </div>

                    <div className='moreSolutionOuter'>
                        <div className="moreSolutionInner moreSolutionGreen">
                            <a href="/rentdirect">
                            <div className="green_overlay"></div>
                                <figure><img src="/img/rent_direct_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>
                        <div className="moreSolutionInner moreSolutionSky">
                            <a href="/rentid">
                                <div className="sky_overlay"></div>
                                <figure> <img src="/img/rent_id_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>
                        <div className="moreSolutionInner moreSolutionRed">
                            <a href="/rentshield">
                                <div className="red_overlay"></div>
                                <figure><img src="/img/rent_shield_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionWhite">
                            <a href="/rentai">
                                <div className="white_overlay"></div>
                                <figure><img src="/img/rent_ai_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionYellow">
                            <a href="/rentacademy">
                                <div className="yellow_overlay"></div>
                                <figure> <img src="/img/rent_academy_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            {/* END moreSolutionMain */}
        </>
    )
}

export default RentSuccessPage;